import Vue from 'vue';
import moment from 'moment-timezone';
import Auth from '@/data/Auth';

/* eslint-disable no-param-reassign */
export default {
    state: {
        auth: new Auth(),
    },
    mutations: {
        auth: (state, value) => {
            state.auth = value;
        },
    },
    getters: {
        auth: (state) => state.auth,
    },
    actions: {
        async signOut() {
            await Vue.prototype.$firebase.auth().signOut();
            window.localStorage.removeItem('id_token');
            window.localStorage.removeItem('firebase_user');
            window.localStorage.removeItem('auth_token');
        },
        async signIn(context) {
            return new Promise((resolve, reject) => {
                try {
                    const user = Vue.prototype.$firebase.auth().currentUser;

                    user.getIdToken()
                        .then((token) => {
                            window.localStorage.setItem('id_token', token);
                            window.localStorage.setItem('firebase_user', JSON.stringify(user));

                            context.state.auth.id_token = token;
                            context.state.auth.tz = moment.tz.guess();

                            context.state.auth.exchange({
                                beforesend: () => {
                                    context.rootState.loading = true;
                                },
                                complete: () => {
                                    context.rootState.loading = false;
                                    context.rootState.loaded = true;
                                },
                                success: (op, res, data) => {
                                    if (data) {
                                        if (data.mfa) {
                                            resolve(data);
                                        } else {
                                            window.localStorage.setItem('auth_token', data);
                                            resolve(data);
                                        }
                                    } else {
                                        reject(new Error('Could not find a valid token'));
                                    }
                                },
                                failure: (a, b, returnCode) => {
                                    if (returnCode == 30) {
                                        reject(new Error(returnCode));
                                    } else if (a instanceof Error) {
                                        reject(a);
                                    } else {
                                        reject(new Error(b.meta.display_message));
                                    }
                                },
                            });
                        })
                        .catch(() => {
                            reject(new Error('Could not get Id Token'));
                        });
                } catch (err) {
                    reject(err);
                }
            });
        },
    },
};
/* eslint-enable */
